<script>
  import { fade } from "svelte/transition";
  export let title = "Memproses";
  export let content =
    "Silahkan tunggu, sebaiknya tidak menutup aplikasi hingga proses ini selesai";
</script>

<div
  transition:fade={{ duration: 300 }}
  id="loadingPageSquare"
  class="fixed top-0 left-0 z-50 flex items-center justify-center w-screen h-screen p-10 text-center bg-white bg-opacity-75"
>
  <div
    class="p-4 text-gray-600 transition-all duration-100 ease-in-out bg-green-100 rounded-lg shadow-xl animate-bounce w-52"
  >
    <span class="inline-block text-lg font-bold">
      {title}
    </span><br />
    <p class="text-sm">{content}</p>
  </div>
</div>
